import { createSlice } from '@reduxjs/toolkit';
import {
  addLiveSale,
  updateLiveSale,
  updateLiveSaleStatus,
  deleteLiveSale,
  getAllLiveSales,
  getActiveLiveSales,
  getLiveSaleById,
} from './ThunkAction';
import { iLiveSaleState, REDUCER_NAME } from './Types';

const initialState: iLiveSaleState = {
  isLoading: false,
  //@ts-ignore
  liveSaleList: [], // Initialize as empty array
  activeLiveSales: [], // Initialize as empty array
  errorMessage: null,
  currentLiveSale: null,
};

export const liveSaleSlice = createSlice({
  name: REDUCER_NAME,
  initialState,
  reducers: {
    resetLiveSaleState: () => initialState,
    clearCurrentLiveSale: (state) => {
      state.currentLiveSale = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Add Live Sale
      .addCase(addLiveSale.pending, (state) => {
        state.isLoading = true;
        state.errorMessage = null;
      })
      .addCase(addLiveSale.fulfilled, (state, action) => {
        if (action.payload?.data) {
          const newSale = {
            ...action.payload.data,
            id: action.payload.data.id,
            productName: action.payload.data.productName,
            productPrice: action.payload.data.productPrice,
            startTime: new Date(action.payload.data.startTime).toISOString(),
            endTime: new Date(action.payload.data.endTime).toISOString(),
            discount: action.payload.data.discount,
            status: action.payload.data.status || 'Upcoming',
          };

          // Ensure liveSaleList is always an array
          if (!Array.isArray(state.liveSaleList)) {
            //@ts-ignore
            state.liveSaleList = [];
          }
           //@ts-ignore
          state.liveSaleList = [newSale, ...state.liveSaleList];
        }
        state.isLoading = false;
        state.errorMessage = null;
      })
      .addCase(addLiveSale.rejected, (state, action) => {
        state.errorMessage =
        //@ts-ignore
          action.payload?.message || 'Failed to add live sale';
        state.isLoading = false;
      })

      // Update Live Sale
      .addCase(updateLiveSale.pending, (state) => {
        state.isLoading = true;
        state.errorMessage = null;
      })
      .addCase(updateLiveSale.fulfilled, (state, action) => {
        if (action.payload?.data) {
          // Ensure liveSaleList is always an array
          if (!Array.isArray(state.liveSaleList)) {
             //@ts-ignore
            state.liveSaleList = [];
          }
 //@ts-ignore
          const index = state.liveSaleList.findIndex(
            (item) => item.id === action.payload?.data?.id
          );
          if (index !== -1) {
            state.liveSaleList[index] = action.payload.data;
          }
        }
        state.isLoading = false;
      })
      .addCase(updateLiveSale.rejected, (state, action) => {
        state.errorMessage =
        //@ts-ignore
          action.payload?.message || 'Failed to update live sale';
        state.isLoading = false;
      })

      // Update Live Sale Status
      .addCase(updateLiveSaleStatus.pending, (state) => {
        state.isLoading = true;
        state.errorMessage = null;
      })
      // .addCase(updateLiveSaleStatus.fulfilled, (state, action) => {
      //   if (action.payload?.data) {
      //     // Ensure liveSaleList is always an array
      //     if (!Array.isArray(state.liveSaleList)) {
      //       state.liveSaleList = [];
      //     }

      .addCase(updateLiveSaleStatus.fulfilled, (state, action) => {
        if (action.payload?.data) {
          if (!Array.isArray(state.liveSaleList)) {
             //@ts-ignore
            state.liveSaleList = [];
          }

          const { id, status } = action.payload.data;
           //@ts-ignore
          const index = state.liveSaleList.findIndex((item) => item.id === id);
          if (index !== -1) {
            state.liveSaleList[index].status = status;
          }
        }
        state.isLoading = false;
      })
      .addCase(updateLiveSaleStatus.rejected, (state, action) => {
        state.errorMessage =
        //@ts-ignore
          action.payload?.message || 'Failed to update live sale status';
        state.isLoading = false;
      })

      // Delete Live Sale
      .addCase(deleteLiveSale.pending, (state) => {
        state.isLoading = true;
        state.errorMessage = null;
      })
      .addCase(deleteLiveSale.fulfilled, (state, action) => {
        if (action.payload?.data) {
          // Ensure liveSaleList is always an array
          if (!Array.isArray(state.liveSaleList)) {
             //@ts-ignore
            state.liveSaleList = [];
          }
 //@ts-ignore
          state.liveSaleList = state.liveSaleList.filter(
            (item) => item.id !== action.payload?.data?.id
          );
        }
        state.isLoading = false;
      })
      .addCase(deleteLiveSale.rejected, (state, action) => {
        state.errorMessage =
        //@ts-ignore
          action.payload?.message || 'Failed to delete live sale';
        state.isLoading = false;
      })

      // Get All Live Sales
      .addCase(getAllLiveSales.pending, (state) => {
        state.isLoading = true;
        state.errorMessage = null;
      })
      .addCase(getAllLiveSales.fulfilled, (state, action) => {
        if (action.payload?.data) {
           //@ts-ignore
          state.liveSaleList = action.payload.data;
        } else {
           //@ts-ignore
          state.liveSaleList = []; // Set to empty array if no data
        }
        state.isLoading = false;
      })
      .addCase(getAllLiveSales.rejected, (state, action) => {
        state.errorMessage =
        //@ts-ignore
          action.payload?.message || 'Failed to fetch live sales';
        state.isLoading = false;
         //@ts-ignore
        state.liveSaleList = []; // Set to empty array on error
      })

      // Get Active Live Sales
      .addCase(getActiveLiveSales.pending, (state) => {
        state.isLoading = true;
        state.errorMessage = null;
      })
      .addCase(getActiveLiveSales.fulfilled, (state, action) => {
        if (action.payload?.data) {
          state.activeLiveSales = action.payload.data;
        } else {
          state.activeLiveSales = []; 
        }
        state.isLoading = false;
      })
      .addCase(getActiveLiveSales.rejected, (state, action) => {
        state.errorMessage =
        //@ts-ignore
          action.payload?.message || 'Failed to fetch active live sales';
        state.isLoading = false;
        state.activeLiveSales = []; // Set to empty array on error
      })

      // Get Live Sale By ID
      .addCase(getLiveSaleById.pending, (state) => {
        state.isLoading = true;
        state.errorMessage = null;
      })
      .addCase(getLiveSaleById.fulfilled, (state, action) => {
        if (action.payload?.data) {
          state.currentLiveSale = action.payload.data;
        } else {
          state.currentLiveSale = null; // Set to null if no data
        }
        state.isLoading = false;
      })
      .addCase(getLiveSaleById.rejected, (state, action) => {
        state.errorMessage =
        //@ts-ignore
          action.payload?.message || 'Failed to fetch live sale';
        state.isLoading = false;
        state.currentLiveSale = null; // Set to null on error
      });
  },
});

export const { resetLiveSaleState, clearCurrentLiveSale } =
  liveSaleSlice.actions;
export default liveSaleSlice.reducer;
